import React from 'react';

export const STANDARD_RELATIONSHIPS = [
  'Parent',
  'Spouse / Partner',
  'Child',
  'Sibling',
  'Legal Guardian',
  'Professional Caregiver / Home Health Aide',
  'Other Relative',
  'Other Non-Relative',
];

const RelationshipTypeSelect = ({ value, onChange, className = '', hasError = false }) => {
  const borderCls = hasError
    ? 'border-red-500 ring-1 ring-red-500'
    : 'border-gray-300 dark:border-slate-700';
  return (
    <div className={className}>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-3 py-2 bg-white dark:bg-slate-800 border rounded-md text-sm text-gray-900 dark:text-white ${borderCls}`}
      >
        <option value="">Select a relationship…</option>
        {STANDARD_RELATIONSHIPS.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RelationshipTypeSelect;
